export default "__VITE_ASSET__246f78e5__"